var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"resume"}},[_c('Loader',{attrs:{"timeout":"10"}}),_c('a',{staticClass:"button is-info d-none",attrs:{"href":_vm.url}},[_vm._v("DOWNLOAD CV")]),_c('PDFViewer',{attrs:{"url":_vm.url}}),_c('a',{staticClass:"button is-info",attrs:{"href":_vm.url}},[_vm._v("DOWNLOAD CV")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }